<!-- 人工登记汇款列表 -->
<template>
  <div>
    <div class="opage">
      <!-- 资金/人工登记汇款 -->
      <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.manualRegistrationRemittance')"></baseBreadcrumb>
      <tableTab :val.sync="form.status" :list="[
        // 待确认
        { name: this.$t('message.toBeConfirmed') + `(${tabList[1].num})`, value: '0' },
        // 已确认
        { name: this.$t('message.confirmed'), value: '1' },
        // 全部汇款
        { name: this.$t('message.allOfTheRemittance'), value: '' },]
        " :fun="getData">
        <div class="tabBtns">
          <!-- 新增 -->
          <el-button type="primary" @click="add" v-if="isAuth(323)">{{
        $t("message.add")
      }}</el-button>
        </div>
      </tableTab>
      <div class="searchBox">
        <!-- 客户ID -->
        <el-input size="small" :placeholder="$t('message.clientID')" v-model="form.user_id" clearable></el-input>
        <!-- 汇款人 -->
        <el-input size="small" :placeholder="$t('message.remitter')" v-model="form.realname" clearable></el-input>
        <!-- 汇款金额 -->
        <el-input size="small" :placeholder="$t('message.remittanceAmoun')" v-model="form.amount" clearable></el-input>
        <el-date-picker size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange" range-separator="-" v-model="value" :default-time="['00:00:00', '23:59:59']"
          :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')" clearable>
        </el-date-picker>
        <!-- 支付方式 -->
        <el-select size="small" v-model="form.bill_method" :placeholder="$t('message.methodPayment')" clearable>
          <el-option v-for="item in BillMethod" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
        <div class="btns">
          <!-- 筛选 -->
          <el-button size="small" type="primary" @click="getData">{{
        $t("message.filter")
      }}</el-button>
          <!-- 重置 -->
          <!-- <el-button size="small" @click="chongZhi">{{
            $t("message.reset")
                        }}</el-button> -->
        </div>
      </div>
      <div style="padding: 0 20px">
        <el-table class="tableMy" :data="tableData"
          :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
        'text-align': 'center',
        background: '#f8f8f8',
      }">
          <el-table-column type="index" width="50" label="No"></el-table-column>
          <!-- 提出时间 -->
          <el-table-column property="created_at" :label="$t('message.forwardTime')" width="100"></el-table-column>
          <!-- 财务确认时间 -->
          <el-table-column property="confirm_at" :label="$t('message.financialConfirmationTime')"
            width="100"></el-table-column>
          <!-- 支付方式 -->
          <el-table-column property="bill_method_name" :label="$t('message.methodPayment')"></el-table-column>
          <!-- 汇款人 -->
          <el-table-column property="pay_realname" :label="$t('message.theRemitter')"></el-table-column>
          <!-- 汇款金额(円) -->
          <el-table-column property="pay_amount" :label="$t('message.remittanceAmoun')"></el-table-column>
          <!-- 汇款截图 -->
          <el-table-column property="pay_image" :label="$t('message.remittanceScreenshots')">
            <template slot-scope="scope">
              <div>
                <myImage :imgList="scope.row.pay_image" :showDel="false"></myImage>
              </div>
            </template>
          </el-table-column>
          <!-- 汇款客户 -->
          <el-table-column :label="$t('message.remittanceCustomer')">
            <template slot-scope="scope">
              <div class="keHu">
                <p>{{ scope.row.user ? scope.row.user.username : "" }}</p>
                <p>ID:{{ scope.row.user_id }}</p>
                <!-- 联系方式 -->
                <el-popover popper-class="zdyPopver" placement="bottom-start" trigger="click"
                  :title="$t('message.customerContactInformation') + ':'" v-if="scope.row.user">
                  <div class="xianShiLXXX">
                    <!-- 业务员 -->
                    <p>{{ $t("message.salesman") }}:暂无</p>
                    <p>Email：{{ scope.row.user.email }}</p>
                    <p>Mobile：{{ scope.row.user.mobile }}</p>
                  </div>
                  <p class="lianXiFangShi" slot="reference">
                    {{ $t("message.contact") }}
                  </p>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <!-- 汇款客户ID -->
          <el-table-column property="user_id" :label="$t('message.remittanceCustomerID')"></el-table-column>
          <!-- 名义 -->
          <el-table-column property="client_bill_reason" :label="$t('message.mingYi')"></el-table-column>
          <!-- 转账备注 -->
          <el-table-column property="pay_remark" :label="$t('message.transferNote')"></el-table-column>
          <!-- 追加人 -->
          <el-table-column property="created_by_name" :label="$t('message.addName')"></el-table-column>

          <!-- 确认人 -->
          <el-table-column property="confirm_by_name" :label="$t('message.affirmName')"></el-table-column>

          <!-- 汇款状态 -->
          <el-table-column property="status" :label="$t('message.emittanceState')">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.status == 0">
                  <!-- 待确认 -->
                  {{ $t("message.toBeConfirmed") }}
                </span>
                <span v-if="scope.row.status == 1">
                  <!-- 已确认 -->
                  {{ $t("message.confirmed") }}
                </span>
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column property="name" :label="$t('message.operation')">
            <template slot-scope="scope">
              <div class="btnGroup">
                <!-- 确认 -->
                <el-button v-if="scope.row.status == 0 && isAuth(324)" type="primary" class="secondary" size="small"
                  @click="confirmMe(scope.row)">{{ $t("message.confirm") }}</el-button>
                <!-- 删除 -->
                <el-button v-if="scope.row.status == 0 && isAuth(484)" type="primary" class="dark" size="small"
                  @click="financialCancel(scope.row)">{{ $t("message.delete") }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <zDialog ref="dialog" :config="{
        width: '536px',
        title: diaTitle,
        btnTxt: btnTxt,
      }">
        <div class="editForm">
          <el-form ref="ruleForm" :model="aProductInformation" :rules="rules" label-position="left" label-width="138px">
            <!-- 汇款人 -->
            <el-form-item :label="$t('message.theRemitter') + ':'" prop="pay_realname">
              <el-input v-model="aProductInformation.pay_realname"></el-input>
            </el-form-item>
            <!-- 客户ID -->
            <el-form-item v-if="diaTitle != $t('message.add')" :label="$t('message.clientID') + ':'" prop="user_id">
              <el-input v-model="aProductInformation.user_id"></el-input>
            </el-form-item>
            <!-- 单子金额. 円 -->
            <el-form-item :label="$t('message.theAmountOnTheBillIsYen') + ':'" prop="pay_amount">
              <el-input v-model="aProductInformation.pay_amount"></el-input>
            </el-form-item>
            <!-- 支付方式 -->
            <el-form-item :label="$t('message.methodPayment') + ':'" prop="bill_method">
              <el-select v-model="aProductInformation.bill_method" :placeholder="$t('message.methodPayment')">
                <el-option v-for="item in BillMethod" :key="item.key" :label="item.value" :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 汇款截图 -->
            <el-form-item :label="$t('message.remittanceScreenshots') + ':'">
              <div class="imgUp">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="handleAvatarSuccess" name="file" accept=".jpg,.jpeg,.png"
                  :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-image :src="aProductInformation.pay_image" v-if="aProductInformation.pay_image"
                  style="width: 80px; height: 80px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
            <!-- 转账备注 -->
            <el-form-item :label="$t('message.transferNoteNei') + ':'" prop="pay_remark">
              <textarea v-model="aProductInformation.pay_remark"></textarea>
            </el-form-item>
            <!-- 名义 -->
            <el-form-item :label="$t('message.mingYi') + ':'" prop="client_bill_reason">
              <textarea v-model="aProductInformation.client_bill_reason"></textarea>
            </el-form-item>
          </el-form>
        </div>
      </zDialog>
    </div>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
import tableTab from "../components/tableTab.vue";
export default {
  data() {
    return {
      activeName: "",
      form: {},
      value: [],
      total: 0,
      loading: null,
      tableData: [],
      diaTitle: "",
      btnTxt: [this.$t('message.save'), this.$t('message.cancel')],
      BillMethod: [], //支付方式列表
      //单个商品信息
      aProductInformation: {
        pay_realname: "",
        pay_amount: "",
        bill_method: "",
        pay_image: "",
        pay_remark: "",
      },
      tabList: [
        { tabName: "", num: 0 },
        { tabName: "", num: 0 },
        { tabName: "", num: 0 },
      ], //tab列表数量
      // 修改商品表单验证
      rules: {
        pay_realname: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_amount: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        bill_method: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        pay_remark: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        user_id: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        client_bill_reason: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    myImage,
    tableTab,
  },
  computed: {},
  mounted() {
    this.getData();
    this.getbillMethods();
    this.financialStoreListNum()
  },
  methods: {
    // 人工登记汇款列表统计
    financialStoreListNum() {
      this.$api.tabTotalApi.financialStoreListNum().then(res => {
        this.tabList = res.data
      })
    },
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.start_time = null;
        this.form.end_time = null;
      } else {
        this.form.start_time = this.value[0];
        this.form.end_time = this.value[1];
      }

      this.$api.financialApi
        .billNoOwnerFinancialStoreList(this.form)
        .then((res) => {
          // console.log("事件名", res.data.data);
          if (res.code != 0) return this.$message.error(res.msg);
          // 接下来的操作
          this.tableData = res.data.data;
          this.total = res.data.total
          this.$forceUpdate();
        });
    },
    // 重置
    chongZhi() {
      this.value = [];
      this.form = {};
    },
    // 获取支付列表
    getbillMethods() {
      this.$api.financialApi.billBillMethod().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.msg);
        res.data.forEach((element) => {
          element.key = Number(element.key);
        });
        this.BillMethod = res.data;
      });
    },
    handleAvatarSuccess(res, file) {
      this.loading.close();
      this.aProductInformation.pay_image = res.data;
      this.validateField("pay_image", "ruleForm");
    },
    // 手动触发表单验证
    validateField(type, formRef) {
      if (this.aProductInformation[type])
        this.aProductInformation[type] = this.aProductInformation[type].trim();
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },

    // 确认汇款订单
    confirmMe(row) {
      // 汇款确认
      this.diaTitle = this.$t("message.confirmationOfRemittance");
      // 将需要的值填入
      this.aProductInformation = JSON.parse(JSON.stringify(row));
      this.aProductInformation.user_id = "";
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              //事件
              this.$refs.dialog.close();
              // 点击确定事件
              this.$api.financialApi
                .billNoOwnerFinancialStoreConfirm(this.aProductInformation)
                .then((res) => {
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.$refs.dialog.close();
                });
            } else {
            }
          });
        },
        () => {
          // 点击取消事件
        }, [this.$t('message.save'), this.$t('message.cancel')]
      );
    },
    // 新增人工登记汇款
    add() {
      this.aProductInformation = JSON.parse(
        JSON.stringify({
          pay_realname: "",
          pay_amount: "",
          bill_method: "",
          pay_image: "",
          pay_remark: "",
          user_id: "0",
        })
      );
      // 新增
      this.diaTitle = this.$t("message.add");

      this.$forceUpdate()
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              // 点击确定事件
              this.$api.financialApi
                .billNoOwnerFinancialStore(this.aProductInformation)
                .then((res) => {
                  // console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.$refs.dialog.close();
                });
            } else {
            }
          });
        },
        () => {
          // 点击取消事件
        }
        , [this.$t('message.save'), this.$t('message.cancel')]);
    },
    // 删除
    financialCancel(row) {
      this.$confirm(
        this.$t(
          "message.areYouSureToDelete"
        ),
        // 汇款回退提醒
        this.$t("message.deleteOrder"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.financialApi
            .financialCancel({ id: row.id })
            .then((res) => {

              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);
              this.getData();

            });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {

      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {

      this.form.page = val;
      this.getData();
    },
  },
};
</script>
<style lang='scss' scoped='scoped'>
@import "@/css/mixin.scss";

.routerView {
  height: 100%;
}

.opage {
  background-color: #f8f8f8;
  height: 100%;
}

.searchBox {
  display: flex;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 15px;

  >* {
    flex: 0 0 180px;
    margin-right: 20px;
  }

  .el-date-editor {
    flex: 0 0 389px;
  }

  .btns {
    flex: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 0;

    .el-button {
      width: 64px;
      margin-left: 15px;
    }
  }
}

/deep/.tableMy {
  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.editForm {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/.avatar-uploader .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  textarea {
    width: 245px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #edeff4;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    padding: 12px 16px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>
<style lang="scss">
.zdyPopver {
  padding: 0;

  .el-popover__title {
    padding: 13px 16px;
    background: #f8f8f8;
    border-radius: 4px 4px 0px 0px;
    margin-bottom: 0;
  }

  .popper__arrow {
    display: none;
  }
}

.xianShiLXXX {
  padding: 16px;

  p {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>